import {
  answerEvaluationCreateSchema,
  answerEvaluationSchema,
} from "@/schema/console/checking-assessments/AnswerEvaluation";
import { z } from "zod";

export const answerContentSchema = z.object({
  id: z.number(),
  content: z.string(),
  answer: z.number(),
  extension_note: z.string().nullable(),
  answer_evaluations: z.array(answerEvaluationSchema),
});

export const answerContentCreateSchema = z.object({
  answer_contents: z.array(
    z.object({
      id: z.number(),
      answer_evaluations: z.array(answerEvaluationCreateSchema),
    }),
  ),
});

export type AnswerContent = z.infer<typeof answerContentSchema>;
